import React, { ReactNode } from 'react';
import ConfirmationModal from './ConfirmationModal';

interface IProps {
  children: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  trackContext?: string;
  trackCancelAction?: string;
  trackConfirmAction?: string;
}

const WarningModal = ({
  children,
  onCancel,
  onConfirm,
  trackContext,
  trackConfirmAction,
  trackCancelAction,
}: IProps) => (
  <ConfirmationModal
    open
    onClose={onCancel}
    onSubmit={onConfirm}
    header={'Warning'}
    cancelActionLabel={'No'}
    confirmActionLabel={'Yes'}
    trackContext={trackContext}
    trackConfirmAction={trackConfirmAction}
    trackCancelAction={trackCancelAction}
  >
    {children}
  </ConfirmationModal>
);

export default WarningModal;
